import { FC } from "react";
import { COLORS } from "shared/consts";

type ChevronLeftIconProps = {
  fill?: string;
};
export const ChevronLeftIcon: FC<ChevronLeftIconProps> = ({ fill }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.47115 11.4692L13.9711 5.99976L15.0289 7.06337L10.0636 12.001L15.0289 16.9387L13.9711 18.0023L8.47115 12.5328C8.32959 12.392 8.25 12.2007 8.25 12.001C8.25 11.8014 8.32959 11.61 8.47115 11.4692Z"
        fill={fill || COLORS.NEUTRAL.MUTED}
      />
    </svg>
  );
};
